

// 1.

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   Select,
//   MenuItem
// } from "@mui/material";

// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import { PrAnalysisTab2Api } from "../../../../../../api/Api";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const formattedCurrentDate = date.toISOString().split("T")[0];
//   const oneWeekAgo = new Date(date);
//   oneWeekAgo.setDate(oneWeekAgo.getDate() - 0);
//   const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];

//   return {
//     Today: formattedCurrentDate,
//     LastWeek: formattedOneWeekAgo,
//   };
// }

// function PrAnalysisTab5() {

//   const chartRef = useRef();

//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [viewMode, setViewMode] = useState("all");

//   const [fromDate, setFromDate] = useState(
//     getDateTimeForDashboardTab1().LastWeek
//   );
//   const [toDate, setToDate] = useState(
//     getDateTimeForDashboardTab1().Today
//   );

//   const metric = "KW";

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LCODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     DT1: fromDate,
//     DT2: toDate,
//   };

//   useEffect(() => {
//     async function fetchInverters() {
//       try {

//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           {
//             params: {
//               LOGIN_ID: credentials.LOGIN_ID,
//               LOC_CODE: credentials.LCODE,
//               PASS_KEY: credentials.PASS_KEY,
//               WEB_KEY: credentials.WEB_KEY,
//               TYP: "I",
//             },
//           }
//         );

//         const feederList = res.data?.FEED || [];

//         setInverters(feederList);

//         if (feederList.length > 0) {
//           setSelectedKeys([feederList[0].feeder_id]);
//         }

//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   const fetchChartData = async () => {

//     if (selectedKeys.length === 0) {
//       setChartData(null);
//       return;
//     }

//     setLoading(true);

//     try {

//       let datasets = [];
//       let labels = [];

//       const plantRes = await PrAnalysisTab2Api(credentials);
//       const plantData = plantRes?.data || [];

//       labels = plantData.map((d) => d.DT || "");

//       if (viewMode === "irradiance" || viewMode === "all") {

//         datasets.push({
//           type: "bar",
//           label: "Irradiance [W/m²]",
//           data: plantData.map((d) => parseFloat(d.RAD ?? 0)),
//           backgroundColor: "#efcc00",
//           borderColor: "#efcc00",
//           borderWidth: 1,
//           yAxisID: "y",
//         });

//       }

//       if (viewMode === "total" || viewMode === "all") {

//         datasets.push({
//           type: "line",
//           label: "Total [kW] Plant",
//           data: plantData.map((d) => parseFloat(d.POWER ?? 0)),
//           borderColor: "green",
//           tension: 0.3,
//           borderWidth: 2,
//           pointRadius: 1,
//           yAxisID: "y1",
//         });

//       }

//       if (viewMode === "active" || viewMode === "all") {

//         for (const inv of inverters) {

//           if (!selectedKeys.includes(inv.feeder_id)) continue;

//           const res = await axios.post(
//             `${BaseUrl}CMN_08InvLog/post_INV_LOG`,
//             new URLSearchParams({
//               LOGIN_ID: credentials.LOGIN_ID,
//               PASS_KEY: credentials.PASS_KEY,
//               WEB_KEY: credentials.WEB_KEY,
//               MTRNO: inv.feeder_id,
//               DT1: fromDate,
//               DT2: toDate,
//             })
//           );

//           const apiData = res.data?.data || [];

//           datasets.push({
//             type: "line",
//             label: `${inv.name} Active Power`,
//             data: apiData.map((d) => parseFloat(d[metric] ?? 0)),
//             borderColor:
//               "#" + Math.floor(Math.random() * 16777215).toString(16),
//             tension: 0.3,
//             borderWidth: 1,
//             pointRadius: 1,
//             yAxisID: "y1",
//           });

//         }

//       }

//       setChartData({ labels, datasets });

//     } catch (err) {
//       console.log(err);
//       setChartData(null);
//     }

//     setLoading(false);
//   };

//   const handleToggle = (key) =>
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );

//   useEffect(() => {
//     if (selectedKeys.length > 0) {
//       fetchChartData();
//     }
//   }, [selectedKeys, viewMode]);

//   return (
//     <div style={{ padding: "10px" }}>

//       <Typography variant="h5" fontWeight="bold" mb={1}>
//         Power Performance
//       </Typography>

//       {/* INVERTER LIST */}

//       <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: 1,
//           }}
//         >

//           {inverters.map((inv) => (

//             <FormControlLabel
//               key={inv.feeder_id}
//               sx={{
//                 "& .MuiTypography-root": {
//                   fontSize: "12px"
//                 }
//               }}
//               control={
//                 <Checkbox
//                   size="small"
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={`${inv.name} [${inv.kwp} kWp]`}
//             />

//           ))}

//         </Box>
//       </Paper>

//       <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 1 }}>

//         <label>From:</label>

//         <input
//           type="date"
//           value={fromDate}
//           onChange={(e) => setFromDate(e.target.value)}
//         />

//         <label>To:</label>

//         <input
//           type="date"
//           value={toDate}
//           onChange={(e) => setToDate(e.target.value)}
//         />

//         <Select
//           size="small"
//           value={viewMode}
//           onChange={(e) => setViewMode(e.target.value)}
//         >
//           <MenuItem value="all">All</MenuItem>
//           <MenuItem value="irradiance">Irradiance</MenuItem>
//           <MenuItem value="total">Total Plant</MenuItem>
//           <MenuItem value="active">Active Power</MenuItem>
//         </Select>

//         <TbRefresh
//           style={{ fontSize: "1.5rem", cursor: "pointer" }}
//           onClick={fetchChartData}
//         />

//         <DownloadJpegButton
//           targetRef={chartRef}
//           fileName={`Inverter Wise Active Power Comparison.jpeg`}
//         />

//       </Box>

//       <Paper ref={chartRef} sx={{ p: 2, height: 350 }}>

//         {loading ? (

//           <Typography sx={{ textAlign: "center", mt: 12 }}>
//             Loading...
//           </Typography>

//         ) : chartData ? (

//           <Line
//             data={chartData}
//             options={{
//               responsive: true,
//               maintainAspectRatio: false,

//               scales: {

//                 y: {
//                   type: "linear",
//                   position: "left",
//                   title: {
//                     display: true,
//                     text: "Irradiance",
//                   },
//                 },

//                 y1: {
//                   type: "linear",
//                   position: "right",
//                   grid: {
//                     drawOnChartArea: false,
//                   },
//                   title: {
//                     display: true,
//                     text: "Power",
//                   },
//                 },

//               },

//               plugins: {
//                 legend: {
//                   position: "top",
//                 },
//               },
//             }}
//           />

//         ) : (

//           <Typography sx={{ textAlign: "center", mt: 12 }}>
//             No data available
//           </Typography>

//         )}

//       </Paper>

//     </div>
//   );
// }

// export default PrAnalysisTab5;


// 2.

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   Select,
//   MenuItem
// } from "@mui/material";

// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import { PrAnalysisTab2Api } from "../../../../../../api/Api";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const formattedCurrentDate = date.toISOString().split("T")[0];
//   const oneWeekAgo = new Date(date);
//   oneWeekAgo.setDate(oneWeekAgo.getDate() - 0);
//   const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];

//   return {
//     Today: formattedCurrentDate,
//     LastWeek: formattedOneWeekAgo,
//   };
// }

// function PrAnalysisTab5() {

//   const chartRef = useRef();

//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [viewMode, setViewMode] = useState("all");

//   const [fromDate, setFromDate] = useState(
//     getDateTimeForDashboardTab1().LastWeek
//   );
//   const [toDate, setToDate] = useState(
//     getDateTimeForDashboardTab1().Today
//   );

//   const metric = "KW";

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LCODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     DT1: fromDate,
//     DT2: toDate,
//   };

//   useEffect(() => {
//     async function fetchInverters() {
//       try {

//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           {
//             params: {
//               LOGIN_ID: credentials.LOGIN_ID,
//               LOC_CODE: credentials.LCODE,
//               PASS_KEY: credentials.PASS_KEY,
//               WEB_KEY: credentials.WEB_KEY,
//               TYP: "I",
//             },
//           }
//         );

//         const feederList = res.data?.FEED || [];

//         setInverters(feederList);

//         if (feederList.length > 0) {
//           setSelectedKeys([feederList[0].feeder_id]);
//         }

//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   const fetchChartData = async () => {

//     if (selectedKeys.length === 0) {
//       setChartData(null);
//       return;
//     }

//     setLoading(true);

//     try {

//       let datasets = [];
//       let labels = [];

//       const plantRes = await PrAnalysisTab2Api(credentials);
//       const plantData = plantRes?.data || [];

//       labels = plantData.map((d) => d.DT || "");

//       if (viewMode === "irradiance" || viewMode === "all") {

//         datasets.push({
//           type: "bar",
//           label: "Irradiance [W/m²]",
//           data: plantData.map((d) => parseFloat(d.RAD ?? 0)),
//           backgroundColor: "#efcc00",
//           borderColor: "#efcc00",
//           borderWidth: 1,
//           yAxisID: "y",
//         });

//       }

//       if (viewMode === "total" || viewMode === "all") {

//         datasets.push({
//           type: "line",
//           label: "Total [kW] Plant",
//           data: plantData.map((d) => parseFloat(d.POWER ?? 0)),
//           borderColor: "green",
//           tension: 0.3,
//           borderWidth: 2,
//           pointRadius: 1,
//           yAxisID: "y1",
//         });

//       }

//       if (viewMode === "active" || viewMode === "all") {

//         for (const inv of inverters) {

//           if (!selectedKeys.includes(inv.feeder_id)) continue;

//           const res = await axios.post(
//             `${BaseUrl}CMN_08InvLog/post_INV_LOG`,
//             new URLSearchParams({
//               LOGIN_ID: credentials.LOGIN_ID,
//               PASS_KEY: credentials.PASS_KEY,
//               WEB_KEY: credentials.WEB_KEY,
//               MTRNO: inv.feeder_id,
//               DT1: fromDate,
//               DT2: toDate,
//             })
//           );

//           const apiData = res.data?.data || [];

//           datasets.push({
//             type: "line",
//             label: `${inv.name} Active Power`,
//             data: apiData.map((d) => parseFloat(d[metric] ?? 0)),
//             borderColor:
//               "#" + Math.floor(Math.random() * 16777215).toString(16),
//             tension: 0.3,
//             borderWidth: 1,
//             pointRadius: 1,
//             yAxisID: "y1",
//           });

//         }

//       }

//       setChartData({ labels, datasets });

//     } catch (err) {
//       console.log(err);
//       setChartData(null);
//     }

//     setLoading(false);
//   };

//   const handleToggle = (key) =>
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );

//   useEffect(() => {
//     if (selectedKeys.length > 0) {
//       fetchChartData();
//     }
//   }, [selectedKeys, viewMode]);

//   return (
//     <div style={{ padding: "10px" }}>

//       <Typography variant="h5" fontWeight="bold" mb={1}>
//         Power Performance
//       </Typography>

//       {/* INVERTER LIST */}

//       <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: 1,
//           }}
//         >

//           {inverters.map((inv) => (

//             <FormControlLabel
//               key={inv.feeder_id}
//               sx={{
//                 "& .MuiTypography-root": {
//                   fontSize: "12px"
//                 }
//               }}
//               control={
//                 <Checkbox
//                   size="small"
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={`${inv.name} [${inv.kwp} kWp]`}
//             />

//           ))}

//         </Box>
//       </Paper>

//       <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 1 }}>

//         <label>From:</label>

        // <input
        //   type="date"
        //   value={fromDate}
        //   onChange={(e) => setFromDate(e.target.value)}
        // />

        // <label>To:</label>

        // <input
        //   type="date"
        //   value={toDate}
        //   onChange={(e) => setToDate(e.target.value)}
        // />

//         <Select
//           size="small"
//           value={viewMode}
//           onChange={(e) => setViewMode(e.target.value)}
//         >
//           <MenuItem value="all">All</MenuItem>
//           <MenuItem value="irradiance">Irradiance</MenuItem>
//           <MenuItem value="total">Total Plant</MenuItem>
//           <MenuItem value="active">Active Power</MenuItem>
//         </Select>

//         <TbRefresh
//           style={{ fontSize: "1.5rem", cursor: "pointer" }}
//           onClick={fetchChartData}
//         />

//         <DownloadJpegButton
//           targetRef={chartRef}
//           fileName={`Inverter Wise Active Power Comparison.jpeg`}
//         />

//       </Box>

//       <Paper ref={chartRef} sx={{ p: 2, height: 350 }}>

//         {loading ? (

//           <Typography sx={{ textAlign: "center", mt: 12 }}>
//             Loading...
//           </Typography>

//         ) : chartData ? (

//           <Line
//             data={chartData}
//             options={{
//               responsive: true,
//               maintainAspectRatio: false,

//               scales: {

//                 y: {
//                   type: "linear",
//                   position: "left",
//                   title: {
//                     display: true,
//                     text: "Irradiance",
//                   },
//                 },

//                 y1: {
//                   type: "linear",
//                   position: "right",
//                   grid: {
//                     drawOnChartArea: false,
//                   },
//                   title: {
//                     display: true,
//                     text: "Power",
//                   },
//                 },

//               },

//               plugins: {
//                 legend: {
//                   position: "top",
//                 },
//               },
//             }}
//           />

//         ) : (

//           <Typography sx={{ textAlign: "center", mt: 12 }}>
//             No data available
//           </Typography>

//         )}

//       </Paper>

//     </div>
//   );
// }

// export default PrAnalysisTab5;

// 3.

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   Tabs,
//   Tab,
// } from "@mui/material";

// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import { PrAnalysisTab2Api } from "../../../../../../api/Api";
// import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// function getDateTimeForDashboardTab1(date = new Date()) {
//   const formattedCurrentDate = date.toISOString().split("T")[0];
//   const oneWeekAgo = new Date(date);
//   oneWeekAgo.setDate(oneWeekAgo.getDate() - 0);

//   return {
//     Today: formattedCurrentDate,
//     LastWeek: oneWeekAgo.toISOString().split("T")[0],
//   };
// }

// function PrAnalysisTab5() {
//   const chartRef = useRef();

//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [viewMode, setViewMode] = useState("all");
//   const [tabValue, setTabValue] = useState("inverters");

//   const [fromDate, setFromDate] = useState(
//     getDateTimeForDashboardTab1().LastWeek
//   );
//   const [toDate, setToDate] = useState(
//     getDateTimeForDashboardTab1().Today
//   );

//   const metric = "KW";

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LCODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//     DT1: fromDate,
//     DT2: toDate,
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           {
//             params: {
//               LOGIN_ID: credentials.LOGIN_ID,
//               LOC_CODE: credentials.LCODE,
//               PASS_KEY: credentials.PASS_KEY,
//               WEB_KEY: credentials.WEB_KEY,
//               TYP: "I",
//             },
//           }
//         );

//         const feederList = res.data?.FEED || [];
//         setInverters(feederList);

//         if (feederList.length > 0) {
//           setSelectedKeys([feederList[0].feeder_id]);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Tab change
//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);

//     if (newValue === "all") {
//       const allKeys = inverters.map((inv) => inv.feeder_id);
//       setSelectedKeys(allKeys);
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Toggle checkbox
//   const handleToggle = (key) =>
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );

//   // 🔹 Fetch chart data
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) {
//       setChartData(null);
//       return;
//     }

//     setLoading(true);

//     try {
//       let datasets = [];
//       let labels = [];

//       const plantRes = await PrAnalysisTab2Api(credentials);
//       const plantData = plantRes?.data || [];

//       labels = plantData.map((d) => d.DT || "");

//       if (viewMode === "irradiance" || viewMode === "all") {
//         datasets.push({
//           type: "bar",
//           label: "Irradiance [W/m²]",
//           data: plantData.map((d) => parseFloat(d.RAD ?? 0)),
//           backgroundColor: "#efcc00",
//           borderColor: "#efcc00",
//           borderWidth: 1,
//           yAxisID: "y",
//         });
//       }

//       if (viewMode === "total" || viewMode === "all") {
//         datasets.push({
//           type: "line",
//           label: "Total [kW] Plant",
//           data: plantData.map((d) => parseFloat(d.POWER ?? 0)),
//           borderColor: "green",
//           tension: 0.3,
//           borderWidth: 2,
//           pointRadius: 1,
//           yAxisID: "y1",
//         });
//       }

//       if (viewMode === "active" || viewMode === "all") {
//         for (const inv of inverters) {
//           if (!selectedKeys.includes(inv.feeder_id)) continue;

//           const res = await axios.post(
//             `${BaseUrl}CMN_08InvLog/post_INV_LOG`,
//             new URLSearchParams({
//               LOGIN_ID: credentials.LOGIN_ID,
//               PASS_KEY: credentials.PASS_KEY,
//               WEB_KEY: credentials.WEB_KEY,
//               MTRNO: inv.feeder_id,
//               DT1: fromDate,
//               DT2: toDate,
//             })
//           );

//           const apiData = res.data?.data || [];

//           datasets.push({
//             type: "line",
//             label: `${inv.name}`,
//             data: apiData.map((d) => parseFloat(d[metric] ?? 0)),
//             borderColor:
//               "#" + Math.floor(Math.random() * 16777215).toString(16),
//             tension: 0.3,
//             borderWidth: 1,
//             pointRadius: 1,
//             yAxisID: "y1",
//           });
//         }
//       }

//       setChartData({ labels, datasets });
//     } catch (err) {
//       console.log(err);
//       setChartData(null);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     if (selectedKeys.length > 0) {
//       fetchChartData();
//     }
//   }, [selectedKeys, viewMode]);

//   return (
//     <div style={{ padding: "10px" }}>
//       <Typography variant="h5" fontWeight="bold" mb={1}>
//         Power Performance
//       </Typography>

//       {/* 🔹 Tabs + Inverter List */}
//       <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
//         <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 2 }}>
//           <Tab label="All" value="all" />
//           <Tab label="Inverters" value="inverters" />
//         </Tabs>

//         {tabValue === "inverters" && (
//           <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//             {inverters.map((inv) => (
//               <FormControlLabel
//                 key={inv.feeder_id}
//                 sx={{
//                   "& .MuiTypography-root": {
//                     fontSize: "12px",
//                   },
//                 }}
//                 control={
//                   <Checkbox
//                     size="small"
//                     checked={selectedKeys.includes(inv.feeder_id)}
//                     onChange={() => handleToggle(inv.feeder_id)}
//                   />
//                 }
//                 label={`${inv.name} [${inv.kwp} kWp]`}
//               />
//             ))}
//           </Box>
//         )}
//       </Paper>

//       {/* 🔹 Controls */}
//       <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 1 }}>
//         <label>From:</label>
//         <input
//           type="date"
//           value={fromDate}
//           onChange={(e) => setFromDate(e.target.value)}
//         />

//         <label>To:</label>
//         <input
//           type="date"
//           value={toDate}
//           onChange={(e) => setToDate(e.target.value)}
//         />

//         <TbRefresh
//           style={{ fontSize: "1.5rem", cursor: "pointer" }}
//           onClick={fetchChartData}
//         />

//         <DownloadJpegButton
//           targetRef={chartRef}
//           fileName={`Inverter Wise Active Power Comparison.jpeg`}
//         />
//       </Box>

//       {/* 🔹 Chart */}
//       <Paper ref={chartRef} sx={{ p: 2, height: 350 }}>
//         {loading ? (
//           <Typography sx={{ textAlign: "center", mt: 12 }}>
//             Loading...
//           </Typography>
//         ) : chartData ? (
//           <Line
//             data={chartData}
//             options={{
//               responsive: true,
//               maintainAspectRatio: false,
//               scales: {
//                 y: {
//                   type: "linear",
//                   position: "left",
//                   title: {
//                     display: true,
//                     text: "Irradiance",
//                   },
//                 },
//                 y1: {
//                   type: "linear",
//                   position: "right",
//                   grid: {
//                     drawOnChartArea: false,
//                   },
//                   title: {
//                     display: true,
//                     text: "Power",
//                   },
//                 },
//               },
//               plugins: {
//                 legend: {
//                   position: "top",
//                 },
//               },
//             }}
//           />
//         ) : (
//           <Typography sx={{ textAlign: "center", mt: 12 }}>
//             No data available
//           </Typography>
//         )}
//       </Paper>
//     </div>
//   ); 
// }

// export default PrAnalysisTab5;



// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   Switch,
// } from "@mui/material";

// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import { PrAnalysisTab2Api } from "../../../../../../api/Api";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// // ✅ 5AM fallback
// function getToday5AMToNow() {
//   const now = new Date();
//   const start = new Date();
//   start.setHours(5, 0, 0, 0);

//   if (now < start) {
//     start.setDate(start.getDate() - 1);
//   }

//   const format = (date) => {
//     const pad = (n) => n.toString().padStart(2, "0");
//     return `${pad(date.getDate())}-${date.toLocaleString("en-GB", {
//       month: "long",
//     })}-${date.getFullYear()} ${pad(date.getHours())}:${pad(
//       date.getMinutes()
//     )}:${pad(date.getSeconds())}`;
//   };

//   return {
//     from: format(start),
//     to: format(now),
//   };
// }

// // ✅ Date Formatter
// function formatDateTime(dateStr, isStart = true) {
//   const date = new Date(dateStr);

//   if (isStart) {
//     date.setHours(0, 0, 0, 0);
//   } else {
//     date.setHours(23, 59, 59, 0);
//   }

//   const pad = (n) => n.toString().padStart(2, "0");

//   return `${pad(date.getDate())}-${date.toLocaleString("en-GB", {
//     month: "long",
//   })}-${date.getFullYear()} ${pad(date.getHours())}:${pad(
//     date.getMinutes()
//   )}:${pad(date.getSeconds())}`;
// }

// function PrAnalysisTab5() {
//   const chartRef = useRef();

//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [isAllSelected, setIsAllSelected] = useState(false);
//   const [viewMode, setViewMode] = useState("all");

//   // ✅ Date states
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   const metric = "KW";

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LCODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//   };

//   // 🔹 Fetch inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           {
//             params: {
//               LOGIN_ID: credentials.LOGIN_ID,
//               LOC_CODE: credentials.LCODE,
//               PASS_KEY: credentials.PASS_KEY,
//               WEB_KEY: credentials.WEB_KEY,
//               TYP: "I",
//             },
//           }
//         );

//         const feederList = res.data?.FEED || [];
//         setInverters(feederList);

//         if (feederList.length > 0) {
//           setSelectedKeys([feederList[0].feeder_id]);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 Select All
//   const handleSelectAll = (e) => {
//     const checked = e.target.checked;
//     setIsAllSelected(checked);

//     if (checked) {
//       setSelectedKeys(inverters.map((inv) => inv.feeder_id));
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   // 🔹 Toggle checkbox
//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   useEffect(() => {
//     setIsAllSelected(
//       inverters.length > 0 && selectedKeys.length === inverters.length
//     );
//   }, [selectedKeys, inverters]);

//   // 🔥 MAIN FUNCTION
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) {
//       setChartData(null);
//       return;
//     }

//     setLoading(true);

//     try {
//       let datasets = [];
//       let allLabelsSet = new Set();

//       let from, to;

//       if (fromDate && toDate) {
//         from = formatDateTime(fromDate, true);
//         to = formatDateTime(toDate, false);
//       } else {
//         const range = getToday5AMToNow();
//         from = range.from;
//         to = range.to;
//       }

//       const plantRes = await PrAnalysisTab2Api({
//         ...credentials,
//         DT1: from,
//         DT2: to,
//       });

//       const plantData = plantRes?.data || [];
//       plantData.forEach((d) => allLabelsSet.add(d.DT));

//       let inverterResponses = [];

//       for (const inv of inverters) {
//         if (!selectedKeys.includes(inv.feeder_id)) continue;

//         const res = await axios.post(
//           `${BaseUrl}CMN_08InvLog/post_INV_LOG`,
//           new URLSearchParams({
//             LOGIN_ID: credentials.LOGIN_ID,
//             PASS_KEY: credentials.PASS_KEY,
//             WEB_KEY: credentials.WEB_KEY,
//             MTRNO: inv.feeder_id,
//             DT1: from,
//             DT2: to,
//           })
//         );

//         const apiData = res.data?.data || [];
//         apiData.forEach((d) => allLabelsSet.add(d.DT));

//         inverterResponses.push({
//           name: inv.name,
//           data: apiData,
//         });
//       }

//       const allLabels = Array.from(allLabelsSet).sort(
//         (a, b) => new Date(a) - new Date(b)
//       );

//       if (viewMode === "total" || viewMode === "all") {
//         const plantMap = {};
//         plantData.forEach((d) => {
//           plantMap[d.DT] = parseFloat(d.POWER ?? 0);
//         });

//         datasets.push({
//           type: "line",
//           label: "Total [kW] Plant",
//           data: allLabels.map((l) => plantMap[l] ?? null),
//           borderColor: "green",
//           tension: 0.3,
//           yAxisID: "y1",
//         });
//       }

//       if (viewMode === "irradiance" || viewMode === "all") {
//         const radMap = {};
//         plantData.forEach((d) => {
//           radMap[d.DT] = parseFloat(d.RAD ?? 0);
//         });

//         datasets.push({
//           type: "bar",
//           label: "Irradiance",
//           data: allLabels.map((l) => radMap[l] ?? null),
//           backgroundColor: "#efcc00",
//           yAxisID: "y",
//         });
//       }

//       inverterResponses.forEach((inv) => {
//         const dataMap = {};
//         inv.data.forEach((d) => {
//           dataMap[d.DT] = parseFloat(d[metric] ?? 0);
//         });

//         datasets.push({
//           type: "line",
//           label: inv.name,
//           data: allLabels.map((l) => dataMap[l] ?? null),
//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           tension: 0.3,
//           yAxisID: "y1",
//         });
//       });

//       setChartData({ labels: allLabels, datasets });
//     } catch (err) {
//       console.log(err);
//       setChartData(null);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     if (selectedKeys.length > 0) {
//       fetchChartData();
//     }
//   }, [selectedKeys, viewMode]);

//   return (
//     <div style={{ padding: "10px" }}>
//       <Typography variant="h5" fontWeight="bold">
//         Performance Power
//       </Typography>

//       {/* 🔹 Inverter + Date Section */}
//       <Paper sx={{ p: 2, mb: 2 }}>
//         <FormControlLabel
//           control={
//             <Switch
//               checked={isAllSelected}
//               onChange={handleSelectAll}
//             />
//           }
//           label="Select All Inverters"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   size="small"
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>

//         {/* ✅ Date Controls (same line) */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
//           <Typography variant="">From:</Typography>
//           <input
//             type="date"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//             // style={{ padding: "2px 5px", border: "1px solid #ccc" }}
//           />

       

//           <Typography variant="body2">To:</Typography>
//           <input
//             type="date"
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//             // style={{ padding: "2px 5px", border: "1px solid #ccc" }}
//           />

//           <TbRefresh
//             style={{ fontSize: "18px", cursor: "pointer" }}
//             onClick={fetchChartData}
//           />
//         </Box>
//       </Paper>

//       {/* 🔹 Chart */}
//       <Paper sx={{ p: 2, height: 350 }}>
//         {loading ? (
//           <Typography align="center">Loading...</Typography>
//         ) : chartData ? (
//           <Line
//             ref={chartRef}
//             data={chartData}
//             options={{
//               responsive: true,
//               maintainAspectRatio: false,
//               scales: {
//                 y: { position: "left" },
//                 y1: {
//                   position: "right",
//                   grid: { drawOnChartArea: false },
//                 },
//               },
//             }}
//           />
//         ) : (
//           <Typography align="center">No data</Typography>
//         )}
//       </Paper>
//     </div>
//   );
// }

// export default PrAnalysisTab5;


import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { TbRefresh } from "react-icons/tb";
import {
  Paper,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  Switch,
} from "@mui/material";

import { BaseUrl } from "../../../../../../api/AxiosApi";
import { PrAnalysisTab2Api } from "../../../../../../api/Api";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// ✅ Get today date for input (YYYY-MM-DD)
const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

// ✅ 5AM fallback
function getToday5AMToNow() {
  const now = new Date();
  const start = new Date();
  start.setHours(5, 0, 0, 0);

  if (now < start) {
    start.setDate(start.getDate() - 1);
  }

  const format = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");
    return `${pad(date.getDate())}-${date.toLocaleString("en-GB", {
      month: "long",
    })}-${date.getFullYear()} ${pad(date.getHours())}:${pad(
      date.getMinutes()
    )}:${pad(date.getSeconds())}`;
  };

  return {
    from: format(start),
    to: format(now),
  };
}

// ✅ Date Formatter
function formatDateTime(dateStr, isStart = true) {
  const date = new Date(dateStr);

  if (isStart) {
    date.setHours(0, 0, 0, 0);
  } else {
    date.setHours(23, 59, 59, 0);
  }

  const pad = (n) => n.toString().padStart(2, "0");

  return `${pad(date.getDate())}-${date.toLocaleString("en-GB", {
    month: "long",
  })}-${date.getFullYear()} ${pad(date.getHours())}:${pad(
    date.getMinutes()
  )}:${pad(date.getSeconds())}`;
}

function PrAnalysisTab5() {
  const chartRef = useRef();

  const [inverters, setInverters] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [viewMode, setViewMode] = useState("all");

  // ✅ Default current date set
  const [fromDate, setFromDate] = useState(getTodayDate());
  const [toDate, setToDate] = useState(getTodayDate());

  const metric = "KW";

  const credentials = {
    LOGIN_ID: sessionStorage.getItem("LoginID"),
    LCODE: sessionStorage.getItem("LCODE"),
    PASS_KEY: "XYZ",
    WEB_KEY: "WEBXYZ321",
  };

  // 🔹 Fetch inverter list
  useEffect(() => {
    async function fetchInverters() {
      try {
        const res = await axios.get(
          `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
          {
            params: {
              LOGIN_ID: credentials.LOGIN_ID,
              LOC_CODE: credentials.LCODE,
              PASS_KEY: credentials.PASS_KEY,
              WEB_KEY: credentials.WEB_KEY,
              TYP: "I",
            },
          }
        );

        const feederList = res.data?.FEED || [];
        setInverters(feederList);

        if (feederList.length > 0) {
          setSelectedKeys([feederList[0].feeder_id]);
        }
      } catch (err) {
        console.error(err);
      }
    }

    fetchInverters();
  }, []);

  // 🔹 Select All
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setIsAllSelected(checked);

    if (checked) {
      setSelectedKeys(inverters.map((inv) => inv.feeder_id));
    } else {
      setSelectedKeys([]);
    }
  };

  // 🔹 Toggle checkbox
  const handleToggle = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key)
        ? prev.filter((k) => k !== key)
        : [...prev, key]
    );
  };

  useEffect(() => {
    setIsAllSelected(
      inverters.length > 0 && selectedKeys.length === inverters.length
    );
  }, [selectedKeys, inverters]);

  // 🔥 MAIN FUNCTION
  const fetchChartData = async () => {
    if (selectedKeys.length === 0) {
      setChartData(null);
      return;
    }

    setLoading(true);

    try {
      let datasets = [];
      let allLabelsSet = new Set();

      let from, to;

      if (fromDate && toDate) {
        from = formatDateTime(fromDate, true);
        to = formatDateTime(toDate, false);
      } else {
        const range = getToday5AMToNow();
        from = range.from;
        to = range.to;
      }

      const plantRes = await PrAnalysisTab2Api({
        ...credentials,
        DT1: from,
        DT2: to,
      });

      const plantData = plantRes?.data || [];
      plantData.forEach((d) => allLabelsSet.add(d.DT));

      let inverterResponses = [];

      for (const inv of inverters) {
        if (!selectedKeys.includes(inv.feeder_id)) continue;

        const res = await axios.post(
          `${BaseUrl}CMN_08InvLog/post_INV_LOG`,
          new URLSearchParams({
            LOGIN_ID: credentials.LOGIN_ID,
            PASS_KEY: credentials.PASS_KEY,
            WEB_KEY: credentials.WEB_KEY,
            MTRNO: inv.feeder_id,
            DT1: from,
            DT2: to,
          })
        );

        const apiData = res.data?.data || [];
        apiData.forEach((d) => allLabelsSet.add(d.DT));

        inverterResponses.push({
          name: inv.name,
          data: apiData,
        });
      }

      const allLabels = Array.from(allLabelsSet).sort(
        (a, b) => new Date(a) - new Date(b)
      );

      if (viewMode === "total" || viewMode === "all") {
        const plantMap = {};
        plantData.forEach((d) => {
          plantMap[d.DT] = parseFloat(d.POWER ?? 0);
        });

        datasets.push({
          type: "line",
          label: "Total [kW] Plant",
          data: allLabels.map((l) => plantMap[l] ?? null),
          borderColor: "green",
          tension: 0.3,
          yAxisID: "y1",
        });
      }

      if (viewMode === "irradiance" || viewMode === "all") {
        const radMap = {};
        plantData.forEach((d) => {
          radMap[d.DT] = parseFloat(d.RAD ?? 0);
        });

        datasets.push({
          type: "bar",
          label: "Irradiance",
          data: allLabels.map((l) => radMap[l] ?? null),
          backgroundColor: "#efcc00",
          yAxisID: "y",
        });
      }

      inverterResponses.forEach((inv) => {
        const dataMap = {};
        inv.data.forEach((d) => {
          dataMap[d.DT] = parseFloat(d[metric] ?? 0);
        });

        datasets.push({
          type: "line",
          label: inv.name,
          data: allLabels.map((l) => dataMap[l] ?? null),
          borderColor:
            "#" + Math.floor(Math.random() * 16777215).toString(16),
          tension: 0.3,
          yAxisID: "y1",
        });
      });

      setChartData({ labels: allLabels, datasets });
    } catch (err) {
      console.log(err);
      setChartData(null);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (selectedKeys.length > 0) {
      fetchChartData();
    }
  }, [selectedKeys, viewMode]);

  return (
    <div style={{ padding: "10px" }}>
      <Typography variant="h5" fontWeight="bold">
        Performance Power
      </Typography>

      <Paper sx={{ p: 2, mb: 2 }}>
        <FormControlLabel
          control={
            <Switch
              checked={isAllSelected}
              onChange={handleSelectAll}
            />
          }
          label="Select All Inverters"
        />

        <Box sx={{ display: "flex", flexWrap: "wrap" }}>
          {inverters.map((inv) => (
            <FormControlLabel
              key={inv.feeder_id}
              control={
                <Checkbox
                  size="small"
                  checked={selectedKeys.includes(inv.feeder_id)}
                  onChange={() => handleToggle(inv.feeder_id)}
                />
              }
              label={inv.name}
            />
          ))}
        </Box>

        {/* ✅ Date Controls */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
          <Typography>From:</Typography>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />

          <Typography>To:</Typography>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />

          <TbRefresh
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={fetchChartData}
          />
        </Box>
      </Paper>

      <Paper sx={{ p: 2, height: 350 }}>
        {loading ? (
          <Typography align="center">Loading...</Typography>
        ) : chartData ? (
          <Line
            ref={chartRef}
            data={chartData}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                y: { position: "left" },
                y1: {
                  position: "right",
                  grid: { drawOnChartArea: false },
                },
              },
            }}
          />
        ) : (
          <Typography align="center">No data</Typography>
        )}
      </Paper>
    </div> 
  );
}

export default PrAnalysisTab5;

// import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
// import { Line } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { TbRefresh } from "react-icons/tb";
// import {
//   Paper,
//   Typography,
//   Box,
//   Checkbox,
//   FormControlLabel,
//   Switch,
// } from "@mui/material";

// import { BaseUrl } from "../../../../../../api/AxiosApi";
// import { PrAnalysisTab2Api } from "../../../../../../api/Api";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// // ✅ Today date (YYYY-MM-DD)
// const getTodayDate = () => {
//   const today = new Date();
//   return today.toISOString().split("T")[0];
// };

// // ✅ fallback (5AM)
// function getToday5AMToNow() {
//   const now = new Date();
//   const start = new Date();
//   start.setHours(5, 0, 0, 0);

//   if (now < start) {
//     start.setDate(start.getDate() - 1);
//   }

//   const format = (date) => {
//     const pad = (n) => n.toString().padStart(2, "0");
//     return `${pad(date.getDate())}-${date.toLocaleString("en-GB", {
//       month: "long",
//     })}-${date.getFullYear()} ${pad(date.getHours())}:${pad(
//       date.getMinutes()
//     )}:${pad(date.getSeconds())}`;
//   };

//   return { from: format(start), to: format(now) };
// }

// // ✅ formatter
// function formatDateTime(dateStr, isStart = true) {
//   const date = new Date(dateStr);

//   if (isStart) {
//     date.setHours(0, 0, 0, 0);
//   } else {
//     date.setHours(23, 59, 59, 0);
//   }

//   const pad = (n) => n.toString().padStart(2, "0");

//   return `${pad(date.getDate())}-${date.toLocaleString("en-GB", {
//     month: "long",
//   })}-${date.getFullYear()} ${pad(date.getHours())}:${pad(
//     date.getMinutes()
//   )}:${pad(date.getSeconds())}`;
// }

// function PrAnalysisTab5() {
//   const chartRef = useRef();

//   const [inverters, setInverters] = useState([]);
//   const [selectedKeys, setSelectedKeys] = useState([]);
//   const [chartData, setChartData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [isAllSelected, setIsAllSelected] = useState(false);
//   const [viewMode, setViewMode] = useState("all");

//   // ✅ default date set
//   const [fromDate, setFromDate] = useState(getTodayDate());
//   const [toDate, setToDate] = useState(getTodayDate());

//   const metric = "KW";

//   const credentials = {
//     LOGIN_ID: sessionStorage.getItem("LoginID"),
//     LCODE: sessionStorage.getItem("LCODE"),
//     PASS_KEY: "XYZ",
//     WEB_KEY: "WEBXYZ321",
//   };

//   // 🔹 inverter list
//   useEffect(() => {
//     async function fetchInverters() {
//       try {
//         const res = await axios.get(
//           `${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`,
//           {
//             params: {
//               LOGIN_ID: credentials.LOGIN_ID,
//               LOC_CODE: credentials.LCODE,
//               PASS_KEY: credentials.PASS_KEY,
//               WEB_KEY: credentials.WEB_KEY,
//               TYP: "I",
//             },
//           }
//         );

//         const feederList = res.data?.FEED || [];
//         setInverters(feederList);

//         if (feederList.length > 0) {
//           setSelectedKeys([feederList[0].feeder_id]);
//         }
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     fetchInverters();
//   }, []);

//   // 🔹 select all
//   const handleSelectAll = (e) => {
//     const checked = e.target.checked;
//     setIsAllSelected(checked);

//     if (checked) {
//       setSelectedKeys(inverters.map((inv) => inv.feeder_id));
//     } else {
//       setSelectedKeys([]);
//     }
//   };

//   const handleToggle = (key) => {
//     setSelectedKeys((prev) =>
//       prev.includes(key)
//         ? prev.filter((k) => k !== key)
//         : [...prev, key]
//     );
//   };

//   useEffect(() => {
//     setIsAllSelected(
//       inverters.length > 0 && selectedKeys.length === inverters.length
//     );
//   }, [selectedKeys, inverters]);

//   // 🔥 MAIN
//   const fetchChartData = async () => {
//     if (selectedKeys.length === 0) {
//       setChartData(null);
//       return;
//     }

//     setLoading(true);

//     try {
//       let datasets = [];
//       let allLabelsSet = new Set();

//       let from, to;

//       if (fromDate && toDate) {
//         from = formatDateTime(fromDate, true);
//         to = formatDateTime(toDate, false);
//       } else {
//         const range = getToday5AMToNow();
//         from = range.from;
//         to = range.to;
//       }

//       const plantRes = await PrAnalysisTab2Api({
//         ...credentials,
//         DT1: from,
//         DT2: to,
//       });

//       const plantData = plantRes?.data || [];
//       plantData.forEach((d) => allLabelsSet.add(d.DT));

//       let inverterResponses = [];

//       for (const inv of inverters) {
//         if (!selectedKeys.includes(inv.feeder_id)) continue;

//         const res = await axios.post(
//           `${BaseUrl}CMN_08InvLog/post_INV_LOG`,
//           new URLSearchParams({
//             LOGIN_ID: credentials.LOGIN_ID,
//             PASS_KEY: credentials.PASS_KEY,
//             WEB_KEY: credentials.WEB_KEY,
//             MTRNO: inv.feeder_id,
//             DT1: from,
//             DT2: to,
//           })
//         );

//         const apiData = res.data?.data || [];
//         apiData.forEach((d) => allLabelsSet.add(d.DT));

//         inverterResponses.push({
//           name: inv.name,
//           data: apiData,
//         });
//       }

//       const allLabels = Array.from(allLabelsSet).sort(
//         (a, b) => new Date(a) - new Date(b)
//       );

//       // 🔹 Plant line
//       if (viewMode === "total" || viewMode === "all") {
//         const plantMap = {};
//         plantData.forEach((d) => {
//           plantMap[d.DT] = parseFloat(d.POWER ?? 0);
//         });

//         datasets.push({
//           type: "line",
//           label: "Total [kW] Plant",
//           data: allLabels.map((l) => plantMap[l] ?? null),
//           borderColor: "green",
//           backgroundColor: "green",
//           tension: 0.4,
//           borderWidth: 3,
//           pointRadius: 2,
//           fill: false,
//           yAxisID: "y1",
//           order: 1,
//         });
//       }

//       // 🔹 Irradiance bar
//       if (viewMode === "irradiance" || viewMode === "all") {
//         const radMap = {};
//         plantData.forEach((d) => {
//           radMap[d.DT] = parseFloat(d.RAD ?? 0);
//         });

//         datasets.push({
//           type: "bar",
//           label: "Irradiance",
//           data: allLabels.map((l) => radMap[l] ?? null),
//           backgroundColor: "#efcc00",
//           yAxisID: "y",
//           order: 2,
//         });
//       }

//       // 🔹 inverter lines
//       inverterResponses.forEach((inv) => {
//         const dataMap = {};
//         inv.data.forEach((d) => {
//           dataMap[d.DT] = parseFloat(d[metric] ?? 0);
//         });

//         datasets.push({
//           type: "line",
//           label: inv.name,
//           data: allLabels.map((l) => dataMap[l] ?? null),
//           borderColor:
//             "#" + Math.floor(Math.random() * 16777215).toString(16),
//           tension: 0.4,
//           borderWidth: 2,
//           pointRadius: 1,
//           fill: false,
//           yAxisID: "y1",
//           order: 1,
//         });
//       });

//       setChartData({ labels: allLabels, datasets });
//     } catch (err) {
//       console.log(err);
//       setChartData(null);
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     if (selectedKeys.length > 0) {
//       fetchChartData();
//     }
//   }, [selectedKeys, viewMode]);

//   return (
//     <div style={{ padding: "10px" }}>
//       <Typography variant="h5" fontWeight="bold">
//         Performance Power
//       </Typography>

//       <Paper sx={{ p: 2, mb: 2 }}>
//         <FormControlLabel
//           control={
//             <Switch
//               checked={isAllSelected}
//               onChange={handleSelectAll}
//             />
//           }
//           label="Select All Inverters"
//         />

//         <Box sx={{ display: "flex", flexWrap: "wrap" }}>
//           {inverters.map((inv) => (
//             <FormControlLabel
//               key={inv.feeder_id}
//               control={
//                 <Checkbox
//                   size="small"
//                   checked={selectedKeys.includes(inv.feeder_id)}
//                   onChange={() => handleToggle(inv.feeder_id)}
//                 />
//               }
//               label={inv.name}
//             />
//           ))}
//         </Box>

//         {/* ✅ Date */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
//           <Typography>From:</Typography>
//           <input
//             type="date"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//           />

//           <Typography>To:</Typography>
//           <input
//             type="date"
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//           />

//           <TbRefresh
//             style={{ fontSize: "18px", cursor: "pointer" }}
//             onClick={fetchChartData}
//           />
//         </Box>
//       </Paper>

//       <Paper sx={{ p: 2, height: 350 }}>
//         {loading ? (
//           <Typography align="center">Loading...</Typography>
//         ) : chartData ? (
//           <Line
//             ref={chartRef}
//             data={chartData}
//             options={{
//               responsive: true,
//               maintainAspectRatio: false,
//               interaction: {
//                 mode: "index",
//                 intersect: false,
//               },
//               plugins: {
//                 legend: { position: "top" },
//                 tooltip: { mode: "index", intersect: false },
//               },
//               scales: {
//                 y: { position: "left" },
//                 y1: {
//                   position: "right",
//                   grid: { drawOnChartArea: false },
//                 },
//               },
//             }}
//           />
//         ) : (
//           <Typography align="center">No data</Typography>
//         )}
//       </Paper>
//     </div>
//   );
// }

// export default PrAnalysisTab5;